import { render, staticRenderFns } from "./CoCheckbox.vue?vue&type=template&id=3f9dd36a&"
import script from "./CoCheckbox.vue?vue&type=script&lang=ts&"
export * from "./CoCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./CoCheckbox.vue?vue&type=style&index=0&id=3f9dd36a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports